import { IndPhrase } from "@shared/models/cat.model";
import { RevRule } from "@shared/models/rev.model";

export class ComplianceIssue {
    
    explanation: string;
    issueId: number;
    phraseId: number;
    
    constructor(issueId: number, explanation: string, phraseId: number) {

        this.explanation = explanation;
        this.issueId = issueId;
        this.phraseId = phraseId;
    }
    remove(phrase : IndPhrase | RevRule) {
        
        let consistencyIssuesToUpdate = phrase.consistencyIssuesToUpdate;
        phrase.consistencyIssuesToUpdate.is_ref_consistent_anchor_update_only = false;

        consistencyIssuesToUpdate.remove.phrase_general_compliance_analysis_results.push({
            issue_id: this.issueId
        })

    }
}